import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { NotificationManager } from "react-notifications";
import { ReajustePacasApi } from "../api/ReajustePacasApi";
import { getErrorFromResponse } from "../../../../../../../../../utility/utils";

const VALORES_PALLET_NUEVO = {
    identificador: "",
    pacas: "",
    observaciones: "",
};

// El valor que se digita es la cantidad real contada; si no hay reajuste todavía
// arranca con las pacas que el sistema tiene registradas
const valoresDeLineas = (lineas) =>
    lineas.map((linea) => ({
        pacas_reales:
            linea.pacas_nuevas !== null && linea.pacas_nuevas !== undefined
                ? linea.pacas_nuevas
                : linea.pacas_actuales,
        observaciones: linea.observaciones || "",
    }));

export const useReajustePacasForm = (fila) => {
    const {
        getLineasPacas,
        guardarReajustePallet,
        eliminarReajustePallet,
        cargando,
    } = ReajustePacasApi();

    const [lineas, setLineas] = useState([]);
    const [productoNombre, setProductoNombre] = useState("");
    const [esConformeBodega, setEsConformeBodega] = useState(true);

    const {
        control: formControl,
        setValue: formSetValue,
        getValues: formGetValues,
        reset: formReset,
        formState: { errors: formErrors },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            lineas: [],
            pallet_nuevo: VALORES_PALLET_NUEVO,
        },
    });

    const CargarLineas = async (sinMascara = false) => {
        try {
            const response = await getLineasPacas(fila, sinMascara);

            setProductoNombre(response.producto_nombre || "");
            setEsConformeBodega(!!response.es_conforme_bodega);
            setLineas(response.lineas);

            formSetValue("lineas", valoresDeLineas(response.lineas));
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener los pallets de la fila",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setLineas([]);
        }
    };

    useEffect(() => {
        CargarLineas();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fila.tipo, fila.producto_id, fila.es_conforme_bodega]);

    // Se guarda al salir de cualquiera de los dos campos de la línea, mandando
    // los dos valores; el backend hace upsert, así que repetirlo no molesta
    const GuardarReajustePallet = async (linea, index) => {
        const valores = formGetValues(`lineas.${index}`) || {};

        const pacasReales = valores.pacas_reales;

        if (pacasReales === "" || pacasReales === null || pacasReales === undefined) {
            return;
        }

        const body = {
            ...fila,
            pacas_nuevas: pacasReales,
            observaciones: valores.observaciones,
        };

        if (linea.pallet_id) {
            body.pallet_id = linea.pallet_id;
        } else {
            body.id = linea.reajuste_id;
            body.identificador_fisico = linea.identificador_fisico;
        }

        try {
            await guardarReajustePallet(body);

            // sin máscara: al salir del campo haciendo clic en un botón, su
            // overlay se interpondría y el clic se perdería
            await CargarLineas(true);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al guardar el reajuste del pallet",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    // Pacas que aparecieron físicamente y no están registradas: el pallet nuevo
    // se crea hasta que se cierra el inventario
    const AgregarPalletNoRegistrado = async () => {
        const palletNuevo = formGetValues("pallet_nuevo") || {};

        if (!palletNuevo.pacas) {
            NotificationManager.warning(
                "Indique las pacas del pallet",
                "Advertencia",
                3000,
            );
            return;
        }

        try {
            await guardarReajustePallet({
                ...fila,
                identificador_fisico: palletNuevo.identificador,
                pacas_nuevas: palletNuevo.pacas,
                observaciones: palletNuevo.observaciones,
            });

            formSetValue("pallet_nuevo", VALORES_PALLET_NUEVO);

            NotificationManager.success("Pallet agregado", "Éxito", 3000);

            await CargarLineas();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al agregar el pallet",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const EliminarReajustePallet = async (linea) => {
        try {
            await eliminarReajustePallet(linea.reajuste_id);

            NotificationManager.success("Reajuste eliminado", "Éxito", 3000);

            await CargarLineas();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al eliminar el reajuste",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    return {
        formControl,
        formErrors,
        formReset,

        lineas,
        productoNombre,
        esConformeBodega,

        GuardarReajustePallet,
        AgregarPalletNoRegistrado,
        EliminarReajustePallet,
        cargando,
    };
};
